import React, { useState, useEffect } from "react";
import { Button, Table, Space, Card, Tag, Select, Row, Col } from "antd";
import { PlusOutlined, EyeOutlined, DownloadOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { post } from "../../../services/services";
import { ApiURL, baseURL } from "../../../services/apiConstants";
import dayjs from "dayjs";

const { Option } = Select;

const PhotographicAnalysisList = () => {
    const navigate = useNavigate();
    const [loader, setLoader] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    const [ships, setShips] = useState([]);
    const [selectedShipId, setSelectedShipId] = useState("");

    const fetchShips = async () => {
        try {
            const FORM_DATA = new FormData();
            const res = await post(ApiURL.list_ships_view_com, FORM_DATA);
            if (res?.status === true) {
                setShips(res?.ships || []);
            }
        } catch (error) {
            console.error("Error fetching ships:", error);
        }
    };

    const fetchInspections = async (shipId) => {
        setLoader(true);
        try {
            const FORM_DATA = new FormData();
            const user_Data = JSON.parse(localStorage.getItem("user_data"));
            FORM_DATA.append("company_id", user_Data?.data?.company?.company_id);
            if (shipId) {
                FORM_DATA.append("ship_id", shipId);
            }
            
            const res = await post(ApiURL.list_inspections, FORM_DATA);
            if (res?.status === true) {
                setDataSource(res?.data || []);
            } else {
                setDataSource([]);
            }
        } catch (error) {
            console.error("Error fetching inspections:", error);
            setDataSource([]);
        } finally {
            setLoader(false);
        }
    };

    useEffect(() => {
        fetchShips();
        fetchInspections("");
    }, []);

    const handleShipChange = (value) => {
        setSelectedShipId(value);
        fetchInspections(value);
    };

    const columns = [
        {
            title: "ID",
            dataIndex: "inspection_id",
            key: "inspection_id",
            width: 80,
            align: 'center',
        },
        {
            title: "Date",
            dataIndex: "inspection_date",
            key: "inspection_date",
            align: 'center',
            render: (text) => text ? dayjs(text).format("YYYY-MM-DD") : "N/A",
        },
        {
            title: "Title",
            dataIndex: "title",
            key: "title",
            align: 'center',
        },
        {
            title: "Ship Name",
            dataIndex: "ship_name",
            key: "ship_name",
            align: 'center',
        },
        {
            title: "Zone",
            dataIndex: "zone_category",
            key: "zone_category",
            align: 'center',
        },
        {
            title: "Type",
            dataIndex: "inspection_type",
            key: "inspection_type",
            align: 'center',
            render: (text) => text ? <Tag color="blue">{text.toUpperCase()}</Tag> : "N/A",
        },
        {
            title: "Action",
            key: "action",
            align: 'center',
            render: (_, record) => (
                <Space size="middle">
                    <Button 
                        type="primary" 
                        size="small"
                        icon={<EyeOutlined />} 
                        onClick={() => navigate(`/view-photographic-analysis/${record.inspection_id}`)}
                        disabled // View functionality not yet requested
                    />
                    {record.report_download_url && (
                        <Button 
                            type="primary" 
                            size="small"
                            style={{ backgroundColor: '#28a745', borderColor: '#28a745' }}
                            icon={<DownloadOutlined />} 
                            onClick={() => {
                                const downloadUrl = record.report_download_url.startsWith('http') 
                                    ? record.report_download_url 
                                    : (baseURL.endsWith('/') && record.report_download_url.startsWith('/')
                                        ? baseURL + record.report_download_url.substring(1)
                                        : baseURL + record.report_download_url);
                                window.open(downloadUrl, '_blank');
                            }}
                        />
                    )}
                </Space>
            ),
        },
    ];

    return (
        <div className="white-container" style={{ padding: "10px" }}>
            <div className="row">
                <div className="col-3">
                    <label className="block-label" style={{ fontWeight: '500', marginBottom: '8px', display: 'block' }}>Select Ship</label>
                    <Select
                        placeholder="---- Select Ship ----"
                        style={{ width: '100%' }}
                        value={selectedShipId}
                        onChange={handleShipChange}
                    >
                        <Option value="">All Ships</Option>
                        {ships.map(ship => (
                            <Option key={ship.id} value={ship.id}>
                                {ship.vessel_name}
                            </Option>
                        ))}
                    </Select>
                </div>
            </div>

            <div className="row" style={{ padding: "15px 10px", marginTop: '10px' }}>
                <div className="col-6" style={{ alignSelf: "center" }}>
                    <div className="theme-content-title text-left">
                        <h3 style={{ margin: 0 }}>Photographic Analysis Information</h3>
                    </div>
                </div>
                <div className="col-6" style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                    <Button 
                        type="primary" 
                        icon={<PlusOutlined />} 
                        onClick={() => navigate("/photographic-analysis-form")}
                        className="save_btn"
                    >
                        Add Inspection
                    </Button>
                </div>
            </div>

            <Table 
                columns={columns} 
                dataSource={dataSource} 
                loading={loader} 
                rowKey="inspection_id"
                bordered
                pagination={{ pageSize: 10 }}
                className="custom-table"
                style={{ marginTop: '10px' }}
            />
        </div>
    );
};

export default PhotographicAnalysisList;
